export const formatText = str => str.toLocaleLowerCase();

export const filterOptions = (text, options, field) => {
  return !text
    ? options
    : options.filter(option => formatText(option[field]).indexOf(formatText(text)) > -1);
};

export const filterVariationCheck = (father, searchText) => {
  if (!searchText) {
    return father;
  }

  return (
    formatText(father.name).indexOf(formatText(searchText)) > -1 ||
    (father.options &&
      father.options.some(opt => formatText(opt.name).indexOf(formatText(searchText)) > -1))
  );
};

export const filterVariationOptions = (searchText, variations) => {
  return !searchText
    ? variations
    : variations.filter(fatherOpt => filterVariationCheck(fatherOpt, searchText));
};



// WEBPACK FOOTER //
// ./src/helpers/search.js